import React, { useState } from "react";
import styles from './invoice_supplier_section.module.css'
import { Content, Dialog, DialogContainer, Flex, Heading, Link, TextField } from "@adobe/react-spectrum";
import { useTranslation } from "react-i18next";
import TrackingCategoryDropDown from "../../../../../components/protected/data-components/TrackingCategoryDropDown";
import { DataProvider } from "../../../../../components/protected/data-components/Contexts/DataContext";
interface IInvoiceFinanceSection {
    invoice: any;
    isEdit: any;
    onChange: (data: any) => void;
}

const InvoiceFinanceSection: React.FC<IInvoiceFinanceSection> = ({ invoice, isEdit, onChange }) => {
    const [showMorefileds, setShowMorefields] = useState<boolean>(false);
    const { t } = useTranslation('invoice');
    const _t = (key: string) => t(`add_update_invoice.${key}`, { ns: 'invoice' });
    const _tt = (key: string) => t(`invoice_common.${key}`, { ns: 'invoice' });

    const handleShowMorefields = () => {
        setShowMorefields(!showMorefileds)
    }

    function SupplierModal() {

        return (
            <Dialog width={{ L: '800px', base: '100%' }} aria-label="Financial Analysis" isDismissable onDismiss={() => setShowMorefields(false)}>
                <Heading marginStart={0} level={2}>
                    {_t(isEdit ? 'financial_analysis' : 'financial_analysis')}
                </Heading>
                <Content>
                    <Flex direction={{ base: 'column', L: 'row' }} gap={'size-150'} marginTop={'size-150'}>
                        <DataProvider>
                            <TrackingCategoryDropDown
                                compKey={'d1'}
                                onValueChange={(value: any, new_value: any) => {
                                    {
                                        console.log(value, new_value);
                                        onChange({ ...invoice, dimension1: value, dimension1Name: new_value })
                                    }
                                }}
                                value={invoice?.dimension1Name}
                                width="50%"
                                isRequired={true}
                                label="Centers"
                                dimension={1}
                            />
                        </DataProvider>
                        <DataProvider>
                            <TrackingCategoryDropDown
                                compKey={'d2'}
                                onValueChange={(value: any, new_value: any) => { onChange({ ...invoice, dimension2: value, dimension2Name: new_value }) }}
                                value={invoice?.dimension2Name}
                                width="50%"
                                isRequired={true}
                                label="Product"
                                dimension={2}
                            />
                        </DataProvider>
                    </Flex>
                    <Flex direction={{ base: 'column', L: 'row' }} gap={'size-150'}>
                        <DataProvider>
                            <TrackingCategoryDropDown
                                compKey={'d3'}
                                onValueChange={(value: any, new_value: any) => { onChange({ ...invoice, dimension3: value, dimension3Name: new_value }) }}
                                value={invoice?.dimension3Name}
                                width="50%"
                                isRequired={true}
                                label="Product"
                                dimension={3}
                            />
                        </DataProvider>
                    </Flex>
                </Content>
            </Dialog>
        )
    }

    return (
        <Flex direction={{ base: 'column', L: 'column' }} UNSAFE_className={styles.main_container} >
            <Flex justifyContent={'end'}>
                <Link UNSAFE_className={styles.show_more_button} onPress={handleShowMorefields} isQuiet>Show more</Link>
            </Flex>
            <Flex>
                <TextField
                    label='Financial Analysis'
                    width={'100%'}
                    isReadOnly
                    value={`${invoice?.dimension1Name ? invoice?.dimension1Name + ', ' : ''} ${invoice?.dimension2Name ? invoice?.dimension2Name + ', ' : ''} ${invoice?.dimension3Name ? invoice?.dimension3Name : ''}`}
                />
            </Flex>

            <DialogContainer onDismiss={() => setShowMorefields(false)}>
                {showMorefileds &&
                    SupplierModal()
                }
            </DialogContainer>
        </Flex>
    )

}

export default InvoiceFinanceSection